import { createContext, useContext } from "react";
import type { DayItem, DraftChange, HospitalData } from "../utils/models";

export type DraftModeContextType = {
	isDraftMode: boolean;
	draftChanges: DraftChange[];
	hasUnsavedChanges: boolean;
	originalData?: HospitalData;
	enableDraftMode: () => void;
	disableDraftMode: () => void;
	publishChanges: () => Promise<void>;
	discardChanges: () => void;
	isPublishing: boolean;
	locallyApprovedRequests: string[];
	isRequestLocallyApproved: (requestId: string) => boolean;
	activeDayData?: DayItem;
};

export const DraftModeContext = createContext<DraftModeContextType | undefined>(undefined);

export const useDraftMode = (): DraftModeContextType => {
	const context = useContext(DraftModeContext);
	if (!context) throw new Error("useDraftMode must be used within DraftModeProvider");

	return context;
};
